// import React, {useState, useRef, useEffect} from 'react';
// import {useDispatch} from "react-redux";
//
// import css from './SliderCalendar.module.css';
// import {generateDaysOfYear} from "../../helpers";
// import {availableDishesActions} from "../../store/slices/menu-slices";
//
//
// const SliderCalendar = () => {
//     const dispatch = useDispatch();
//     const daysOfYear = generateDaysOfYear();
//     const [scrollIndex, setScrollIndex] = useState(0);
//     const [selectedDay, setSelectedDay] = useState(null);
//     const scrollRef = useRef(null);
//
//     useEffect(() => {
//         setToToday();
//     }, []);
//
//     const setToToday = () => {
//         const todayIndex = daysOfYear.findIndex(day => day.isToday);
//         if (todayIndex !== -1) {
//             setScrollIndex(todayIndex);
//             setSelectedDay(daysOfYear[todayIndex]); // Set today's date as selected
//             scrollToDate(todayIndex); // Scroll to today
//         }
//     };
//
//     const handleScrollUp = () => {
//         setScrollIndex((prev) => Math.max(prev - 1, 0));
//         scrollRef.current.scrollBy({top: -40, behavior: 'smooth'});
//     };
//
//     const handleScrollDown = () => {
//         setScrollIndex((prev) => Math.min(prev + 1, daysOfYear.length - 1));
//         scrollRef.current.scrollBy({top: 40, behavior: 'smooth'});
//     };
//
//     const handleDateClick = (day, index) => {
//         dispatch(availableDishesActions.changeDataOfDay(day.dateForBack));
//         setSelectedDay(day); // Set selected day
//         scrollToDate(index); // Scroll to the clicked date
//     };
//
//     const scrollToDate = (index) => {
//         const element = document.getElementById(`date-${index}`);
//         if (element) {
//             element.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'center', // Ensures the clicked date is in the center of the view
//             });
//         }
//     };
//
//
//     return (
//         <div className={css.sliderContainer}>
//             <button
//                 className={css.arrowButton}
//                 onClick={handleScrollUp}
//                 disabled={scrollIndex === 0}
//             >
//                 ▲
//             </button>
//
//             <div className={css.dateList} ref={scrollRef}>
//                 {daysOfYear.map((day, index) => (
//                     <div
//                         key={index}
//                         id={`date-${index}`} // Unique ID for each date
//                         className={`${css.dateItem}
//                             ${day.isWeekend ? css.weekend : ''}
//                             ${day.isToday && !selectedDay ? css.today : ''}
//                             ${selectedDay && selectedDay.date === day.date ? css.selected : ''}`}
//                         onClick={() => handleDateClick(day, index)} // Pass day and index to the click handler
//                     >
//                         <span className={css.date}>{day.date}</span>
//                         <span className={css.dayName}>{day.dayName}</span>
//                     </div>
//                 ))}
//             </div>
//
//             <button
//                 className={css.arrowButton}
//                 onClick={handleScrollDown}
//                 disabled={scrollIndex === daysOfYear.length - 1}
//             >
//                 ▼
//             </button>
//         </div>
//     );
// };
//
// export {SliderCalendar};




import React, {useLayoutEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import css from './SliderCalendar.module.css';
import {generateDaysOfYear} from '../../helpers';
import {availableDishesActions} from '../../store/slices/menu-slices';

const SliderCalendar = () => {
    const dispatch = useDispatch();
    const scrollRef = useRef(null);
    const daysOfYear = generateDaysOfYear();
    const dataOfDay = useSelector((state) => state.availableDishes.dataOfDay);

    useLayoutEffect(() => {
        if (dataOfDay) {
            const index = daysOfYear.findIndex(day => day.dateForBack === dataOfDay);
            const el = document.getElementById(`date-${index}`);
            if (el) {
                // Check if mobile view
                const isMobile = window.innerWidth <= 767;
                if (isMobile) {
                    el.scrollIntoView({behavior: 'auto', inline: 'center'});
                } else {
                    el.scrollIntoView({behavior: 'auto', block: 'center'});
                }
            }
        }
    }, [dataOfDay]);

    const handleDateClick = (day, index) => {
        dispatch(availableDishesActions.changeDataOfDay(day.dateForBack));
        localStorage.setItem('availableDishesSelectedDate', day.dateForBack);
        const el = document.getElementById(`date-${index}`);
        if (el) {
            // Check if mobile view
            const isMobile = window.innerWidth <= 767;
            if (isMobile) {
                el.scrollIntoView({behavior: 'smooth', inline: 'center'});
            } else {
                el.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        }
    };

    const handleScrollLeft = () => {
        const isMobile = window.innerWidth <= 767;
        if (isMobile) {
            scrollRef.current?.scrollBy({left: -80, behavior: 'smooth'});
        } else {
            scrollRef.current?.scrollBy({top: -40, behavior: 'smooth'});
        }
    };

    const handleScrollRight = () => {
        const isMobile = window.innerWidth <= 767;
        if (isMobile) {
            scrollRef.current?.scrollBy({left: 80, behavior: 'smooth'});
        } else {
            scrollRef.current?.scrollBy({top: 40, behavior: 'smooth'});
        }
    };

    return (
        <div className={css.sliderContainer}>
            <button className={css.arrowButton} onClick={handleScrollLeft}>
                <span className={css.desktopArrow}>▲</span>
                <span className={css.mobileArrow}>◀</span>
            </button>

            <div className={css.dateList} ref={scrollRef}>
                {daysOfYear.map((day, index) => (
                    <div
                        key={index}
                        id={`date-${index}`}
                        className={`${css.dateItem}
                            ${day.isWeekend ? css.weekend : ''}
                            ${dataOfDay === day.dateForBack ? css.selected : ''}`}
                        onClick={() => handleDateClick(day, index)}
                    >
                        <span className={css.date}>{day.date}</span>
                        <span className={css.dayName}>{day.dayName}</span>
                    </div>
                ))}
            </div>

            <button className={css.arrowButton} onClick={handleScrollRight}>
                <span className={css.desktopArrow}>▼</span>
                <span className={css.mobileArrow}>▶</span>
            </button>
        </div>
    );
};

export {SliderCalendar};
